// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Jayl","line":"_2pnuu"};